import {
  getConsultes,
  ConsultesDTO,
  ConsultesFilters,
} from '../../api/consultes/getConsultes';
import { GenericState } from '../../types/apiModule';
import { LinksPage, PageInfo } from '../../types/pagination/pagination';
import { Consulta } from '../../types/consultes/consulta.d';
import createApiModule from '../createApiModule';
import { PayloadAction } from '@reduxjs/toolkit';

export interface ConsultesModule extends GenericState<unknown> {
  data: ConsultesDTO;
  filters: ConsultesFilters;
}

const initialState: ConsultesModule = {
  errors: null,
  loading: false,
  data: {
    data: [] as Consulta[],
    links: {} as LinksPage,
    meta: {} as PageInfo,
  },
  filters: {} as ConsultesFilters,
};

const listConsultaModule = createApiModule({
  name: 'listConsultes',
  apiMethod: getConsultes,
  initialState,
  parse: (consultes) => consultes,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onSuccess: () => {},
  onError: () => ({
    message: 'Error llistant les consultes',
  }),
  onValidationError: () => ({
    message: 'Error llistant les consultes',
  }),
  reducers: {
    setFilters(state, action: PayloadAction<ConsultesFilters>) {
      state.filters = action.payload;
    },
  },
});

export const {
  start: listConsultes,
  success: listConsultesOk,
  error: listConsultesKo,
  refresh: listConsultesRefresh,
  reset: listConsultesReset,
  setFilters,
} = listConsultaModule.slice.actions;

export default listConsultaModule;
